import {MockData} from './mockdata';
import {Absence, AbsenceQueryparameters} from './types';
import {numericIdFactory} from '../mocks';
import {getConfig} from '../../config';
import {createEnhancedResourceContainer} from '../utils';

const {
  component: AbsencesLoader,
  useOperations: useAbsencesOperations,
  useResource: useAbsence,
  useResources: useAbsences,
} = createEnhancedResourceContainer<Absence, AbsenceQueryparameters>({
  scopeKey: 'teamId',
  endPoint: '/absences/v-1',
  entityName: 'Absence',
  idKey: 'id',
  mockData: MockData,
  mockIdFactory: numericIdFactory,
  getConfig,
});

export {AbsencesLoader, useAbsencesOperations, useAbsence, useAbsences};

export * from './types';
